"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProfessionalEducation() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="professional-education" className="bg-background py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-20">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start transition-all duration-1000 ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <span className="mb-4 font-sans text-sm font-semibold tracking-widest text-foreground/70 uppercase">
              To Learn
            </span>
            <h2 className="mb-6 font-serif text-4xl text-primary md:text-5xl lg:text-6xl">
              Courses
            </h2>
            <p className="mb-8 max-w-md font-sans text-base leading-relaxed text-foreground/90 md:text-lg">
              For Dentists. Learn how to become a master!!
            </p>
            
            <Button asChild variant="link" className="group h-auto p-0 font-sans text-base font-semibold text-foreground hover:text-primary">
              <Link to="#">
                EXPLORE MORE
                <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>

          {}
          <div ref={cardRef} className={`transition-all duration-1000 delay-200 ${isCardVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <div className="group relative aspect-[4/3] w-full overflow-hidden rounded-xl shadow-2xl lg:aspect-[5/4]">
              {}
              <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/clinical_training_masterclass.png)] bg-cover bg-center transition-transform duration-700 group-hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-secondary/90 transition-opacity duration-500 group-hover:bg-secondary/85" />

              {}
              <div className="absolute inset-0 flex flex-col justify-between p-8 md:p-10">
                <div className="flex justify-start">
                  <Badge className="bg-primary px-3 py-1 font-sans text-xs font-bold tracking-wider text-primary-foreground uppercase hover:bg-primary/90">
                    Course
                  </Badge>
                </div>
                
                <div className="transform transition-transform duration-500 group-hover:translate-y-[-8px]">
                  <h3 className="font-serif text-2xl leading-snug text-white md:text-3xl">
                    The Art of Anterior Esthetics
                  </h3>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}